module.exports = __webpack_public_path__ + "img/bg-mision-1-9.d8a97cb1.jpg";